/* Used global Wordpress php variables to the ajax requests */
/* global articleVars */

import { shareDropdown } from './../../js/front/template-parts/c-social-media-share-dropdown.js';


/**
 * Hero block.
 *
 * @param {Object} block - The block element.
 * @param {Object} articleVars - The article variables.
 * @return {Object} The hero block object.
 */
const heroNewsletter = ( block,  articleVars ) => {

	/**
	 * Get the dropdown HTML.
	 *
	 * @param {Object} post - The post object.
	 * @return {String} The dropdown HTML.
	 */
	const getDroppdownHtml = ( post ) => {

		return shareDropdown( post ) || '';

	}

	/**
	 * Add the dropdown HTML to the block.
	 *
	 * @param {Object} post - The post object.
	 */
	const addDropdownHTML = ( post ) => {

		const dropdownHtml = getDroppdownHtml( post );
		const targetContainer = block.querySelector( '.js-share-dropdown-placement' );
		targetContainer.innerHTML = dropdownHtml;

	}

	return {
		init: () => {

			if ( !articleVars || !articleVars.article ) {

				return;

			}
			addDropdownHTML( articleVars.article );

		},

	};

};

document.querySelectorAll( '.b-hero-newsletter' ).forEach( ( block ) => {

	const blockHeroNewsletter = heroNewsletter( block, articleVars );
	blockHeroNewsletter.init();

} )
